import TooltipWrapper from 'components/Tooltips/TooltipWrapper';
import { ClickableMessage } from './TooltipClickableMessage';

interface ComputedMetricTooltipProps {
  title: string;
  data?: number;
  computedMetrics?: Array<{ value: number; label: string }>;
  isClickable?: boolean;
  isAreaSelectEnabled?: boolean;
  shouldHideClickableMessage?: boolean;
}

const ComputedMetricTooltip = ({
  title,
  data,
  computedMetrics,
  isClickable,
  isAreaSelectEnabled,
  shouldHideClickableMessage
}: ComputedMetricTooltipProps) => {
  return (
    <TooltipWrapper title={title}>
      <div className='flex flex-col p-3'>
        {computedMetrics && computedMetrics.length === 2 ? (
          <div data-cy='tooltip-value-cy' className='text-sm'>
            {computedMetrics[1].value || 0} {computedMetrics[1].label} |{' '}
            {computedMetrics[0].value || 0} {computedMetrics[0].label}
          </div>
        ) : (
          <div data-cy='tooltip-value-cy' className='text-2xl font-bold'>
            {data || 0}%
          </div>
        )}
        {!shouldHideClickableMessage && (
          <ClickableMessage
            isAreaSelectEnabled={isAreaSelectEnabled}
            isClickable={isClickable}
          />
        )}
      </div>
    </TooltipWrapper>
  );
};

export default ComputedMetricTooltip;
